__turbopack_context__.v({
  "aboutDesktop": "page-module-scss-module__-ytPBG__aboutDesktop",
  "aboutDesktopSvg": "page-module-scss-module__-ytPBG__aboutDesktopSvg",
  "aboutGreenLine": "page-module-scss-module__-ytPBG__aboutGreenLine",
  "aboutGreenLineSvg": "page-module-scss-module__-ytPBG__aboutGreenLineSvg",
  "aboutMobile": "page-module-scss-module__-ytPBG__aboutMobile",
  "aboutMobileQueue": "page-module-scss-module__-ytPBG__aboutMobileQueue",
  "aboutMobileQueueSvg": "page-module-scss-module__-ytPBG__aboutMobileQueueSvg",
  "aboutMobileSvg": "page-module-scss-module__-ytPBG__aboutMobileSvg",
  "bredCrumbs_block": "page-module-scss-module__-ytPBG__bredCrumbs_block",
  "parallaxContainer": "page-module-scss-module__-ytPBG__parallaxContainer",
  "svg2": "page-module-scss-module__-ytPBG__svg2",
  "svg3": "page-module-scss-module__-ytPBG__svg3",
  "svgAnim2": "page-module-scss-module__-ytPBG__svgAnim2",
  "title": "page-module-scss-module__-ytPBG__title",
});
